import type {
  PlaceAddressDetails,
  PlaceAutocompleteResponse,
  PlaceSuggestion,
} from '@peles/shared';

/**
 * Address autocomplete backed by the server-side Places proxy (`/api/v1/places`).
 * Uses plain fetch — the endpoints are public so the same client works in the
 * producer app and on tokenized public pages (questionnaire fill). Both
 * functions swallow errors: address inputs degrade to plain text fields.
 */

export async function fetchAddressSuggestions(
  input: string,
  sessionToken?: string,
): Promise<PlaceSuggestion[]> {
  try {
    const params = new URLSearchParams({ input });
    if (sessionToken) params.set('sessionToken', sessionToken);
    const res = await fetch(`/api/v1/places/autocomplete?${params.toString()}`);
    if (!res.ok) return [];
    const data = (await res.json()) as PlaceAutocompleteResponse;
    return data.suggestions ?? [];
  } catch {
    return [];
  }
}

export async function fetchAddressDetails(
  placeId: string,
  sessionToken?: string,
): Promise<PlaceAddressDetails | null> {
  try {
    const params = new URLSearchParams({ placeId });
    if (sessionToken) params.set('sessionToken', sessionToken);
    const res = await fetch(`/api/v1/places/details?${params.toString()}`);
    if (!res.ok) return null;
    return (await res.json()) as PlaceAddressDetails;
  } catch {
    return null;
  }
}
